var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-selector-inline" },
    [
      _c(
        "a-select",
        {
          staticStyle: { width: "100%" },
          model: {
            value: _vm.input,
            callback: function ($$v) {
              _vm.input = $$v
            },
            expression: "input",
          },
        },
        [
          _c("a-select-option", { attrs: { value: "today" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.today"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "yesterday" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.yesterday"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "last7" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.thisWeek"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "last30" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.last30Days"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "this-month" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.thisMonth"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "last-month" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.lastMonth"))),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "custom" } }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.custom"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.input === "custom"
        ? _c("a-range-picker", {
            attrs: { "show-time": "" },
            model: {
              value: _vm.cloneValue,
              callback: function ($$v) {
                _vm.cloneValue = $$v
              },
              expression: "cloneValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }